var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'is-blurred': _vm.isBlurred },attrs:{"id":"product"}},[_c('RPHProductMain',{attrs:{"product":_vm.product}}),_vm._v(" "),(_vm.product.seo_text)?_c('RPHSeoText',{attrs:{"seo-text":_vm.product.seo_text}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }